import React from "react";
import CrudInput from "./CrudInput";

function App() {
  return (
    <>
      <h1>Grocery List</h1>
      <CrudInput />
    </>
    
    );
}

export default App;
